module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "free-form"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Praise for ")]), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Live with Intention")]), _c('span', {
    staticClass: "bold"
  }, [_c('br', {
    staticClass: "calibre1"
  }), _vm._v("and Mary Anne Radmacher")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("“Mary Anne Radmacher has written a book of beauty, creativity, wisdom, and great good will. Her chapter on forgiveness alone is worth the price of "), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("book.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("—Hugh Prather, author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Morning Notes")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Little Book of ")]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Letting")])]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  })]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Go")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("“Many years ago, I bought a framed poster of ‘Live with Intention,’ the inspiring phrase by Mary Anne Radmacher. It has hung on my wall ever since, in seven different houses. I have since bought and read every book she has written. Mary Anne’s newest book is beautiful, artistic, inspiring, and written from h"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("er")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("heart.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("—Dr. Patrick Williams, master certified coach and coauthor of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Becoming a Professional Life Coach: Lessons from the Institute for Life Coach Training")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Total Life Coaching: 50+ Life Lessons, Skills, and Techniques to Enhance Your Practice and")]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v(" Your")])]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  })]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Live with Intention")]), _vm._v(" showed up at the perfect moment in my life, when I needed to be reminded to recommit to ‘the promises I make to myself.’ This book is filled with wisdom and can be read daily as a reminder that we create our lives each day, anew. Mary Anne graciously shares her philosophy and her life stories to show us the way to a life crafted by choices. This book is a treasure chest of ideas which will empower and enrich you"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("r")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("future.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("—Gail McMeekin, LICSW, author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The 12 Secrets of Highly Creative Women")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Power of Positi")]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ve")])]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  })]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Choices")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("“Mary Anne Radmacher is the messenger of our hearts. And "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Live with Intention")]), _vm._v(" is the perfect message for thi"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("s")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("moment.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("—Janet Conner, author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Writing Down Your Soul: How to Activate and Listen to the Extraordinary Vo")]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ice")])]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  })]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Within")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("“Accessible, grounded, joyful, and wise, Mary Anne Radmacher’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Live with Intention")]), _vm._v(" is a pure gift, especially if you’re looking for a practical yet visionary map of contemporary life. Pick up this gem and bask in insight after insight, all of which are solidly based on the realities of twenty-first century life. And it always seems like you’re simply chatting with your best friend. Great graph"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("ics, too.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("—David Kundtz, author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Awakened Mind: One-Minute Wak")]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("e Up")])]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  })]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Calls")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Live with Intention")]), _vm._v(" should be within easy reach of every person who has ever dared to dream. It gives us the tools to believe we can go after those dreams and actually capture them. It is a tool for living life to the"), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("fullest.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("—Pat Ballard, author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("10 Steps to Loving Your Body (No Matter What Siz")]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("e You")])]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  })]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Are)")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Live with Intention")]), _vm._v(" is a wonderful guide for anyone who wants to make every day count. Mary Anne takes the hand of readers and guides them on a fantastic journey to living a passion"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("ate")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("life.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("—Loren Slocum, author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Greatest Love")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Li")]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("fe")])]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  })]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tuneups")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("“Mary Anne Radmacher offers so much concise and powerful inspiration in this book that I was torn between finishing it or running out the door to begin living more intentionally this very minute. Quotes from the author, as well as from wise ones of the past, interspersed with Radmacher’s text leave the lucky reader holding a gem worthy of a permanent spot on the"), _c('span', {
    staticClass: "nobreak"
  }), _vm._v("ni"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("ghtstand.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("—Kathleen Everett, RN, BSN, author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("He")]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("art")])]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  })]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Knocks")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("“Mary Anne Radmacher has created yet another powerfully positive call to action. Inspiring and straightforward, practical and divine—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Live with Intention")]), _vm._v(" is all of this and more. This is a book that is not only a pleasure to read for the first time, but one I look forward to rereading again a"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("nd")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("again.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("—Christine Mason Miller, author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ordinary Sparkli")]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ng")])]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  })]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Moments")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("“Mary Anne’s writing and, more importantly, her life embrace and exude and extol intention. We are now gifted with an exquisitely inspirational and utterly practical guide for doing the same in our own lives. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Live with Intention")]), _vm._v(" is a breath of fresh, life-giving air; one that at times soothes and calms us and at times engages and energizes us to be fully present in this moment and to expect the very best from the precious next. What an extraordinary treasure o"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("f a")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("book!”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("—Deanna Davis, PhD, author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Laugh, Cry, Ea")]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("t Some")])]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  })]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Pie")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_c('em', {
    staticClass: "italic"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("“A book of heaven for our sm"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("all")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("days.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("—Ruth Forman, author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Prayers ")]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Like")])]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  })]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Shoes")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("“Anyone who has ever met Mary Anne Radmacher knows that there are countless things to love and admire about her. She’s a beautiful human being who gives generously from her heart and who genuinely lives everything she teaches. She’s also absolutely delightful, with a childlike wonder that is infectious. (Think polka dots!) But in this moment, what I want to appreciate most about Mary Anne is her self-proclaimed devotion to being a poet and aphorist. In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Live with Intention")]), _vm._v(" Mary Anne has given us another big, juicy basket filled with delectable (and easily digestible) truth fruits. Open the book anywhere and you will be gifted with yummy wisdom from Mary Anne and friends. There’s lot to enjoy right now—and plenty to put in your pockets when you’re hungry for more later! Set an intention right now to live the joyful practices gifted to you in t"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("his")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("book!”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("—Sherry Richert Belul, author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Say it Now: 33 Creative Ways to Say I Love You to the Most Important People in")]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v(" Your")])]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  })]), _c('span', {
    staticClass: "nobreak"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_c('em', {
    staticClass: "italic"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("“Mary Anne’s work saved my life in 2003. After the loss of my mother, I was spiraling down and had no focus and no sense of ME. I had no idea that on my mom’s birthday, which was two months after her death, that I would receive my first sense of healing through Mary Anne’s verse ‘We Laugh to Survive.’ My mom was speaking to me, Mary Anne was speaking to me, and after a two hour meltdown in her booth… I was speaking to my soul to recover. I have represented Mary Anne’s work since that day at my business in Charleston, South Carolina, and that same event will happen at my booth on almost a daily basis. Her verses open those floodgates for grief, fear, and those challenges with friends, family, and work. This connection then transfers to me to hear their story and I then become a conduit to help them find inspiration for themselves or family or friends. It has been an honor to handle Mary Anne’s work and help so many people find confidence, courage and a sense of purpose in their journey"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v(" in")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("life.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body1",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_vm._v("—Owners of JOYCE"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("’s")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("CHOICES")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a06047f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/LiveWithIntention_split_000.vue
// module id = 60
// module chunks = 0